// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Home from "./Home";
import { Blog, Store, ProductDetail } from "./container";
import ProjectDetail from "./container/Work/ProjectDetail";
import BlogDetails from "./container/Blog/BlogDetails";
import Loader from "./components/Loader";
import "./i18n"; // make sure to import your i18n configuration

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1900);
  }, []);

  return (
    <HelmetProvider>
      <Loader isLoading={isLoading} setIsLoading={setIsLoading} />
      {!isLoading && (
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route
              path="/blog"
              element={
                <>
                  <Helmet>
                    <title>The Hyphen Chronicles - Hyphen Tech Blog</title>
                    <meta
                      name="description"
                      content="Deep dives into the intersection of technology, culture, and progress from Hyphen Tech."
                    />
                    <link rel="canonical" href="https://hyphentech.africa/blog" />
                  </Helmet>
                  <Blog />
                </>
              }
            />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route
              path="/store"
              element={
                <>
                  <Helmet>
                    <title>Store - Hyphen Tech</title>
                    <meta
                      name="description"
                      content="Shop apparel from Hyphen Tech, AgriHyphen AI, and Cosebu collections."
                    />
                    <link rel="canonical" href="https://hyphentech.africa/store" />
                  </Helmet>
                  <Store />
                </>
              }
            />
            <Route path="/store/:productId" element={<ProductDetail />} />
          </Routes>
        </Router>
      )}
    </HelmetProvider>
  );
};

export default App;

